module.exports = __webpack_public_path__ + "img/tringl__mobile.057cfa2c.png";